import React, { useState } from 'react';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { useChatStore } from '@store/chatStore';
import { useSocket } from '@hooks/useSocket';
import styles from './ChatContainer.module.css';

export const ChatContainer: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const messages = useChatStore((state) => state.messages);
  const unreadCount = useChatStore((state) => state.unreadCount);
  const { sendMessage } = useSocket();
  
  const handleSendMessage = (message: string) => {
    sendMessage(message);
  };
  
  return (
    <div className={`${styles.container} ${!isExpanded && styles.collapsed}`}>
      <div 
        className={styles.header}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3 className={styles.title}>
          Chat
          {unreadCount > 0 && (
            <span className={styles.badge}>{unreadCount}</span>
          )}
        </h3>
        <button className={styles.toggleButton}>
          {isExpanded ? '−' : '+'}
        </button>
      </div>
      
      {isExpanded && (
        <>
          <MessageList messages={messages} />
          <MessageInput onSend={handleSendMessage} />
        </>
      )}
    </div>
  );
};